/* global Swiper, attachEvent */
// *******************************************************************************
// 1.0 - Testimonial Slider
// *******************************************************************************

const testimonialSliderElements = document.querySelectorAll('[data-slider="testimonial-slider"]');

const testimonialSliderOptions = {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  autoHeight: true,
  navigation: {
    nextEl: '.swiper-button-prev',
    prevEl: '.swiper-button-next',
  },
  breakpoints: {
    767: {
      autoHeight: false,
    },
    992: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    1440: {
      slidesPerView: 3,
      spaceBetween: 60,
    },
  },
};

testimonialSliderElements.forEach((el) => {
  const testimonialSliderParent = el.closest('.testimonial-slider');
  const arrowRight = testimonialSliderParent.querySelector('.arrow-right');
  const arrowLeft = testimonialSliderParent.querySelector('.arrow-left');

  testimonialSliderOptions.navigation.nextEl = arrowRight;
  testimonialSliderOptions.navigation.prevEl = arrowLeft;
  const testimonialSlider = new Swiper(el, testimonialSliderOptions);

  attachEvent('[data-tablink]', 'click', () => {
    testimonialSlider.update();
  });
});
